export enum ControlType {
  Text = 'text',
  Checkbox = 'checkbox',
  File = 'file',
  Image = 'image',
  Select = 'select',
  MultiSelect = 'multiselect',
  Radio = 'radio',
  Color = 'color',
  Date = 'date',
  Custom = 'custom',
  RichText = 'richtext'
}

export enum ErrorDisplayMode {
  Always = 'always',
  Touched = 'touched',
  Dirty = 'dirty'
}
